import { Customer } from 'stoux-shared-types/models/customer'
import { RegisterDto } from '../dtos/register.dto'
import { SignInDto } from '../dtos/sign-in.dto'
import { AuthenticationRepository } from '../repositories/authentication'
import { RegisterSchema } from '../schemas/register.schema'
import { SignInSchema } from '../schemas/sign-in.schema'

type InjectedDependencies = {
    authenticationRepository: AuthenticationRepository
}

export class AuthenticationService {
    private readonly _authenticationRepository: AuthenticationRepository
    constructor({ authenticationRepository }: InjectedDependencies) {
        this._authenticationRepository = authenticationRepository
    }

    public async signIn(dto: SignInDto): Promise<Customer> {
        const validatedPayload = await SignInSchema.safeParseAsync(dto)

        if (!validatedPayload.success) {
            throw new Error('SignIn - Invalid DTO')
        }

        return this._authenticationRepository.signIn(validatedPayload.data)
    }

    public async register(dto: RegisterDto): Promise<Customer> {
        const validatedPayload = await RegisterSchema.safeParseAsync(dto)

        if (!validatedPayload.success) {
            console.log(validatedPayload.error)
            throw new Error('Register - Invalid DTO')
        }

        return this._authenticationRepository.register(validatedPayload.data)
    }

    public async getUserLoggedIn(): Promise<Customer | null> {
        return this._authenticationRepository.getUserLoggedIn()
    }

    public async deleteSession(): Promise<void> {
        return this._authenticationRepository.deleteSession()
    }
}
